import { Component, Type } from '@angular/core';

export type ComponentMapping = Record<string, Type<Component>>;
